import styled from 'styled-components';
import FleetSection from './FleetSection';

export default styled(FleetSection)`
  background-color: var(--grey200);
  height: 100%;
  display: flex;
  flex-direction: column;
`;
